// import React, { useEffect, useMemo, useState } from "react";
// import Footer from "../../components/Footer.jsx";
// import { useNavigate } from "react-router-dom";
// import Navbar from "../../components/Navbar.jsx";
// import axios from "axios";
// import { useAuth } from "../../context/studentAuthContext.jsx";
// import { Check } from "lucide-react";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const PeerMate = () => {
//   const navigate = useNavigate();
//   const { student: authStudent } = useAuth();
//   const [plansFromApi, setPlansFromApi] = useState([]);
//   const [subscribingPlanId, setSubscribingPlanId] = useState(null);

//   const student = useMemo(() => {
//     if (authStudent?.id) return authStudent;
//     try {
//       const raw = localStorage.getItem("student");
//       return raw ? JSON.parse(raw) : null;
//     } catch {
//       return null;
//     }
//   }, [authStudent]);

//   const features = [ 
//     { 
//       title: "Select a Real Human-Race Avatar", 
//       desc: "Choose an AI tutor avatar that feels comfortable and engaging for you.", 
//       img: "9fa9e0191281abaadee462a952b0d92de706f824.png", 
//       bgColor: "bg-red-50" 
//     }, 
//     { 
//       title: "Learn Through AI-Guided Virtual Lessons", 
//       desc: "Study courses with structured lessons designed for clear understanding and exam success.", 
//       img: "668e5bae5d9e7baacf5be47346619b6b2eae970a.png", 
//       bgColor: "bg-purple-50"
//     }, 
//     { 
//       title: "Ask Questions Anytime", 
//       desc: "Get instant, clear explanations whenever you're stuck — no waiting.", 
//       img: "361ae682cbbb3c836f1c3e0f4a270cb424a15433.png", 
//       bgColor: "bg-orange-50" 
//     }, 
//     { 
//       title: "Practice Exam-Focused Questions", 
//       desc: "Work through guided questions and solutions tailored to exam requirements.", 
//       img: "361ae682cbbb3c836f1c3e0f4a270cb424a15433.png", 
//       bgColor: "bg-blue-50" 
//     }, 
//     { 
//       title: "Track Progress & Improve Weak Areas", 
//       desc: "Monitor your learning progress and easily identify topics that need attention.", 
//       img: "9afdad1df6849bdc402453cde66e653e4b14e3a7.png", 
//       bgColor: "bg-green-50" 
//     }, 
//     { 
//       title: "Learn Without Pressure", 
//       desc: "Move at a pace that feels comfortable and effortless for you.", 
//       img: "e7215206269a4fbda7d7d42bfe4e152feb77060d.png", 
//       bgColor: "bg-pink-50" 
//     }, 
//   ];

//   // ✅ Fetch Plans
//   useEffect(() => {
//     const fetchPlans = async () => {
//       try {
//         const res = await axios.get(`${BASE_URL}/api/admin/subscription-plans`, {
//           params: { activeOnly: true },
//         });
//         setPlansFromApi(res.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchPlans();
//   }, []);

//   // ✅ Verify Payment
//   useEffect(() => {
//     const url = new URL(window.location.href);
//     const reference = url.searchParams.get("reference");
//     const paymentType = url.searchParams.get("payment");

//     if (!reference || paymentType !== "subscription") return;

//     axios
//       .post(`${BASE_URL}/api/students/subscriptions/verify-payment`, { reference })
//       .then(() => {
//         url.searchParams.delete("reference");
//         url.searchParams.delete("payment");
//         window.history.replaceState({}, "", url.toString());
//       })
//       .catch(console.error);
//   }, []);

//   // ✅ Normalize Plans
//   const normalizedPlans = plansFromApi.map((plan) => {
//     let features = [];

//     try {
//       features =
//         typeof plan.features === "string"
//           ? JSON.parse(plan.features)
//           : plan.features || [];
//     } catch {
//       features = [];
//     }

//     return {
//       id: plan.id,
//       name: plan.name,
//       price: plan.display_price || `${plan.currency} ${plan.price}`,
//       amount: Number(plan.price || 0),
//       period: plan.billing_label || "",
//       features,
//       buttonText: plan.button_text || "Subscribe",
//       highlight: plan.badge_type === "popular" || plan.badge_type === "recommended",
//       badge: plan.badge_type,
//       themeColor: plan.theme_color || "blue",
//     };
//   });

//   const displayPlans = useMemo(() => {
//     const hasFree = normalizedPlans.some((item) => Number(item.amount) === 0 || String(item.name).toLowerCase() === 'free');
//     if (hasFree) return normalizedPlans;

//     return [
//       {
//         id: 'free-fallback',
//         name: 'Free',
//         price: 'Free',
//         amount: 0,
//         period: 'Starter',
//         features: [
//           '1 hour learning access every 48 hours',
//           'Preference-based course suggestions',
//           'Upgrade anytime for unlimited sessions',
//         ],
//         buttonText: 'Start Free',
//         highlight: false,
//         badge: 'recommended',
//         themeColor: 'green',
//       },
//       ...normalizedPlans,
//     ];
//   }, [normalizedPlans]);

//   // ✅ Subscribe
//   const handleSubscribe = async (plan) => {
//     if (!student?.id) return navigate("/Loginrole");

//     if (Number(plan.amount) === 0) {
//       navigate('/peerchat', {
//         state: {
//           course: 'General Learning',
//           focus: 'Foundational Concepts',
//         },
//       });
//       return;
//     }

//     try {
//       setSubscribingPlanId(plan.id);

//       const res = await axios.post(
//         `${BASE_URL}/api/students/subscriptions/initialize-payment`,
//         {
//           student_id: student.id,
//           plan_id: plan.id,
//           email: student.email,
//           name: student.name,
//         }
//       );

//       if (res.data?.authorization_url) {
//         window.location.href = res.data.authorization_url;
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setSubscribingPlanId(null);
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="bg-white mt-20 min-h-screen font-sans text-slate-800 px-6 py-12 md:px-20">

//         {/* Features Section */}
//         <section className="max-w-7xl mx-auto mb-24">
//           <div className="text-center mb-14">
//             <h2 className="text-3xl font-bold text-slate-900">
//               What You Can Do with PeerMate
//             </h2>
//             <p className="text-slate-500 mt-3">
//               Everything you need to learn smarter, faster, and better
//             </p>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//             {features.map((f, i) => (
//               <div
//                 key={i}
//                 className="group bg-white border border-slate-100 rounded-2xl p-6 hover:shadow-xl transition-all duration-300"
//               >
//                 {/* Icon */}
//                 <div
//                   className={`w-14 h-14 ${f.bgColor} rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}
//                 >
//                   <img
//                     src={f.img}
//                     alt={f.title}
//                     className="w-8 h-8 object-contain"
//                   />
//                 </div>

//                 {/* Title */}
//                 <h3 className="text-lg font-semibold text-slate-900 mb-2">
//                   {f.title}
//                 </h3>

//                 {/* Description */}
//                 <p className="text-sm text-slate-500 leading-relaxed">
//                   {f.desc}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </section>

//         <div className="bg-slate-50 mt-20 min-h-screen px-6 py-14 md:px-20">
//           {/* Header */}
//           <div className="text-center mb-16">
//             <h1 className="text-4xl font-bold text-slate-900">
//               Choose Your Plan
//             </h1>
//             <p className="text-slate-500 mt-3">
//               Unlock premium learning experience with PeerMate
//             </p>
//           </div>

//           {/* Pricing Cards */}
//           <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
//             {displayPlans.map((plan) => (
              
//               <div
//                 key={plan.id}
//                 style={{ borderColor: plan.themeColor === 'green' ? '#22c55e' : undefined }}
//                 className={`relative rounded-2xl p-6 flex flex-col border transition-all duration-300
//                 ${
//                   plan.highlight
//                     ? "bg-white border-blue-600 shadow-xl scale-[1.03]"
//                     : "bg-white border-slate-200 hover:shadow-lg"
//                 }`}
//               >

//                 {/* Badge */}
//                 {plan.badge !== "none" && (
//                   <span className={`absolute top-4 right-4 text-[10px] font-bold uppercase text-white px-2 py-1 rounded-full ${plan.themeColor === 'green' ? 'bg-green-600' : plan.themeColor === 'orange' ? 'bg-orange-600' : plan.themeColor === 'purple' ? 'bg-purple-600' : 'bg-blue-600'}`}>
//                     {plan.badge}
//                   </span>
//                 )}

//                 {/* Title */}
//                 <h3 className="text-lg font-semibold text-slate-800">
//                   {plan.name}
//                 </h3>

//                 {/* Price */}
//                 <div className="mt-4">
//                   <span className={`text-3xl font-bold ${plan.themeColor === 'green' ? 'text-green-600' : plan.themeColor === 'orange' ? 'text-orange-600' : plan.themeColor === 'purple' ? 'text-purple-600' : 'text-blue-600'}`}>
//                     {plan.price}
//                   </span>
//                   <span className="text-sm text-slate-400 ml-2">
//                     {plan.period}
//                   </span>
//                 </div>

//                 {/* Features */}
//                 <ul className="mt-6 space-y-3 flex-grow">
//                   {plan.features.map((feat, i) => (
//                     <li key={i} className="flex items-start gap-2 text-sm text-slate-600">
//                       <Check size={16} className={`mt-0.5 ${plan.themeColor === 'green' ? 'text-green-600' : plan.themeColor === 'orange' ? 'text-orange-600' : plan.themeColor === 'purple' ? 'text-purple-600' : 'text-blue-600'}`} />
//                       {feat}
//                     </li>
//                   ))}
//                 </ul>

//                 {/* Button */}
//                 <button
//                   onClick={() => handleSubscribe(plan)}
//                   disabled={subscribingPlanId === plan.id}
//                   className={`mt-8 py-3 rounded-lg font-semibold text-sm transition-all
//                   ${
//                     plan.highlight || plan.themeColor === 'blue'
//                       ? "bg-blue-600 text-white hover:bg-blue-700"
//                       : plan.themeColor === 'green'
//                       ? "bg-green-600 text-white hover:bg-green-700"
//                       : plan.themeColor === 'orange'
//                       ? "bg-orange-600 text-white hover:bg-orange-700"
//                       : plan.themeColor === 'purple'
//                       ? "bg-purple-600 text-white hover:bg-purple-700"
//                       : "bg-slate-900 text-white hover:bg-slate-800"
//                   }`}
//                 >
//                   {subscribingPlanId === plan.id
//                     ? "Processing..."
//                     : plan.buttonText}
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <Footer />
//     </>
//   );
// };


// export default PeerMate;


import React from "react";
import Footer from "../../components/Footer.jsx";
import Navbar from "../../components/Navbar.jsx";
import { Clock, Sparkles, Rocket, Zap } from "lucide-react";


const PeerMate = () => {

  return (
    <>
      <Navbar />
      
      {/* COMING SOON PAGE */}
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 pt-8">
        <div className="container mx-auto px-4 py-16 md:py-24">
          {/* Main Content */}
          <div className="max-w-4xl mx-auto text-center">
            {/* Animated Icon */}
            <div className="relative mb-8">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-32 h-32 bg-blue-500 rounded-full opacity-10 animate-pulse"></div>
              </div>
              <div className="relative inline-block">
                <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-4 rounded-full shadow-lg animate-bounce">
                  <Rocket className="w-12 h-12 text-white" />
                </div>
              </div>
            </div>

            {/* Title */}
            <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Coming Soon
            </h1>
            
            {/* Description */}
            <p className="text-xl md:text-2xl text-gray-600 mb-4">
              PeerMate is getting ready to revolutionize your learning experience!
            </p>
            <p className="text-lg text-gray-500 mb-12 max-w-2xl mx-auto">
              We're working hard to bring you an intelligent, personalized, and engaging learning platform. 
              Get ready to learn smarter with AI-powered tutoring.
            </p>

            {/* Features Preview */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
                  <Sparkles className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="font-semibold text-gray-800 mb-2">AI-Powered Learning</h3>
                <p className="text-sm text-gray-500">Personalized lessons adapted to your pace</p>
              </div>
              
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
                  <Zap className="w-6 h-6 text-purple-600" />
                </div>
                <h3 className="font-semibold text-gray-800 mb-2">Real-Time Feedback</h3>
                <p className="text-sm text-gray-500">Instant answers and explanations</p>
              </div>
              
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
                  <Clock className="w-6 h-6 text-green-600" />
                </div>
                <h3 className="font-semibold text-gray-800 mb-2">Learn Anytime</h3>
                <p className="text-sm text-gray-500">24/7 access to your AI tutor</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PeerMate;